module.exports = __webpack_public_path__ + "img/bree-3018-09-29.6d274cac.jpg";